/* KTC: one-tap Coffee Club switch in the drawer (see snippets/ktc-drawer-club.liquid).
   Delegated on document so it survives every Section Rendering swap of #CartDrawer. */
(function () {
  if (window.ktcDrawerClubBound) return;
  window.ktcDrawerClubBound = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-ktc-dc-plan]') : null;
    if (!b) return;
    var drawer = b.closest('cart-drawer');
    var wrap = b.closest('.ktc-dc');
    if (!drawer || !wrap) return;
    e.preventDefault();
    if (wrap.classList.contains('is-busy')) return;
    var isOn = wrap.classList.contains('is-on');
    var plan = b.hasAttribute('data-ktc-dc-chip') ? b.getAttribute('data-ktc-dc-plan') : (isOn ? '' : b.getAttribute('data-ktc-dc-plan'));
    if (b.hasAttribute('data-ktc-dc-chip') && b.classList.contains('is-on')) return;
    wrap.classList.add('is-busy');
    var body = {
      id: wrap.getAttribute('data-ktc-dc-key'),
      quantity: parseInt(wrap.getAttribute('data-ktc-dc-qty'), 10),
      selling_plan: plan === '' ? '' : parseInt(plan, 10),
      sections: drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','),
      sections_url: window.location.pathname
    };
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state.errors || !state.sections) throw new Error(state.errors || 'no sections');
      drawer.renderContents(state);
      /* source 'cart-items' so Dawn's own CartItems subscriber does not refetch the
         section a second time (it ignores its own source); the icon bubble is
         already re-rendered through the sections we requested. */
      if (window.publish && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
      }
    })['catch'](function () {
      wrap.classList.remove('is-busy');
    });
  });
  /* Capture phase + stopPropagation: Dawn's <cart-drawer-items> treats any bubbled
     'change' as a quantity input and would throw on this select. */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-ktc-dc-select]') : null;
    if (!sel) return;
    e.stopPropagation();
    var drawer = sel.closest('cart-drawer');
    var wrap = sel.closest('.ktc-dc');
    if (!drawer || !wrap || wrap.classList.contains('is-busy')) return;
    wrap.classList.add('is-busy');
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: wrap.getAttribute('data-ktc-dc-key'),
        quantity: parseInt(wrap.getAttribute('data-ktc-dc-qty'), 10),
        selling_plan: parseInt(sel.value, 10),
        sections: drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','),
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state.errors || !state.sections) throw new Error(state.errors || 'no sections');
      drawer.renderContents(state);
      /* source 'cart-items' so Dawn's own CartItems subscriber does not refetch the
         section a second time (it ignores its own source); the icon bubble is
         already re-rendered through the sections we requested. */
      if (window.publish && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
      }
    })['catch'](function () {
      wrap.classList.remove('is-busy');
    });
  }, true);
})();
